import React, { useEffect, useState, useMemo } from 'react';
import { AgChartsReact } from 'ag-charts-react';
import {
  AgChartOptions,
  AgHistogramSeriesTooltipRendererParams,
} from 'ag-charts-community';
import { Box, Button, Grid, MenuItem, Stack, TextField } from '@mui/material';
// import ChartExample from './Chart';
import { Organization } from '../organisation/OrganizationForm';
import { AppDispatch } from '../../reduxStore/Store';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDashboardData,
  getOrganizationCountBasedOnStatus,
  getUsersCountBasedOnYear,
} from '../../reduxStore/reducer/dashboardReducer';
import { AgGridReact } from 'ag-grid-react';
import { AgChartTheme, ColDef } from 'ag-grid-community';
import { Link } from 'react-router-dom';
import PieChart from './PieChart';
import FacultyDashboard from './FacultyDashboard/FacultyDashboard';
import { getUserById } from '../../reduxStore/reducer/registerReducer';
import ChartExample from './Chart';
import { hasRole } from '../../utils/auth';
import { RoleDefinitions } from '../../auth/role-definitions';

const Dashboard = () => {
  const dispatch = useDispatch<AppDispatch>();

  const getUserDataAndType = useSelector(
    (state: any) => state.register.getUserById,
  );
  const adminType = getUserDataAndType?.data?.type;

  const data = {
    // define your properties here
  };
  useEffect(() => {
    dispatch(
      getUserById({
        id: `${JSON.parse(localStorage.getItem('token') || '{}')}`,
      }),
    );
    // pass the `data` object as an argument
    // dispatch(getSubDisciplineAction());
  }, [dispatch]);

  const formatNumber = (value: number) => {
    // Implement your number formatting logic here
    return value.toString();
  };

  const formatNumberForDisplay = (value: Number) => {
    return Number.isNaN(value) ? '' : value.toLocaleString('en-US');
  };

  const [orgCount, setOrgCount] = useState<Number>(0);
  const [course, setCourse] = useState<Number>(0);
  const [student, setStudent] = useState<Number>(0);
  const [assessment, setAssessment] = useState<Number>(0);
  const [users, setUsers] = useState<Number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const getYearsList = () => {
    const currentYear = new Date().getFullYear();
    const years = ['Overall'];
    for (let year = currentYear; year >= currentYear - 25; year--) {
      years.push(year.toString());
    }
    return years;
  };

  const years = getYearsList();
  const [selectedYear, setSelectedYear] = useState('Overall');
  const [showAllYears, setShowAllYears] = useState(false);

  const handleYearChange = (event: any) => {
    setSelectedYear(event.target.value);
  };

  const toggleShowAllYears = () => {
    setShowAllYears((prev) => !prev);
  };

  const displayedYears = showAllYears ? years : years.slice(0, 15); // Show first 5 years + "Overall"

  const [usersCount, setUsersCount] = useState<any[]>();

  const [options, setOptions] = useState<AgChartOptions>({
    // theme: myTheme,

    autoSize: true,
    data: [],
    title: {
      text: 'Registered Users',
      fontSize: 18,
      spacing: 25,
    },
    footnote: {
      text: 'Users',
    },
    series: [
      {
        type: 'column',
        xKey: 'month',
        yKey: 'count',
        fill: '#0084e7',
        strokeWidth: 0,
        shadow: {
          xOffset: 3,
        },
        label: {
          enabled: true,
          color: '#eeeeee',
          formatter: ({ value }: { value: number }) => formatNumber(value),
        },
        tooltip: {
          renderer: (params: AgHistogramSeriesTooltipRendererParams) => {
            const { yValue, xValue } = params;
            return { title: xValue, content: formatNumber(yValue) };
          },
        },
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        title: {
          text: 'Year',
        },
      },
      {
        type: 'number',
        position: 'left',
        title: {
          text: 'Total Users',
        },
        label: {
          formatter: ({ value }: { value: number }) => formatNumber(value),
        },
      },
    ],
    legend: {
      enabled: false,
    },
  });

  const [cardsData, setCardsData] = useState([]);

  const setLoadingState = (loading: boolean) => {
    setLoading(loading);
  };
  useEffect(() => {
    // Check if getUserDataAndType has data before accessing its properties
    // if (getUserDataAndType?.data) {
    //   const adminType = getUserDataAndType.data.type;

    // Check if data is not already present
    if (hasRole(RoleDefinitions.admin)) {
      dispatch(
        getDashboardData(
          setOrgCount,
          setCourse,
          setStudent,
          setAssessment,
          setUsers,
          setLoadingState,
          selectedYear,
        ),
      );
      dispatch(getUsersCountBasedOnYear(options, setOptions, selectedYear));
      dispatch(getOrganizationCountBasedOnStatus(setCardsData, selectedYear));
    }
    // }
  }, [selectedYear, dispatch]);

  // useEffect(() => {

  // }, [dispatch]);

  const gridStyle = useMemo(() => ({ height: '300px', width: '100%' }), []);

  // useEffect(() => {
  //   dispatch(getDashboardData(setOrgCount, setCourse, setStudent));
  // }, []);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([
    { headerName: 'Name' },
    { field: 'Usage' },
    { field: 'Type' },
    { field: 'Activity' },
    { field: 'total' },
  ]);

  return (
    <>
      {' '}
      <header className='header'>Dashboard</header>
      {hasRole(RoleDefinitions.admin) && (
        <section className='text-gray-600 body-font'>
          <Stack
            direction='row'
            justifyContent='flex-end'
            alignItems='center'
            spacing={3}
            p={1}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div>
                <label htmlFor='yearSelect'>Year:</label>
              </div>
              <div>
                <TextField
                  sx={{ width: '200px' }}
                  id='yearSelect'
                  select
                  value={selectedYear}
                  onChange={handleYearChange}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        style: { maxHeight: 300, overflow: 'auto' },
                      },
                    },
                  }}
                >
                  {displayedYears.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                  {!showAllYears && (
                    <MenuItem disableRipple>
                      <Stack spacing={2} sx={{ width: '100%' }}>
                        <Button
                          variant='outlined'
                          size='small'
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent menu closure
                            toggleShowAllYears();
                          }}
                          sx={{ width: '100%' }}
                        >
                          Expand More
                        </Button>
                      </Stack>
                    </MenuItem>
                  )}
                  {showAllYears && (
                    <MenuItem disableRipple>
                      <Stack spacing={2} sx={{ width: '100%' }}>
                        <Button
                          variant='outlined'
                          size='small'
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleShowAllYears();
                          }}
                          sx={{ width: '100%' }}
                        >
                          Show Less
                        </Button>
                      </Stack>
                    </MenuItem>
                  )}
                </TextField>
              </div>
            </div>
          </Stack>
          <div className='container py-5 mx-auto'>
            <div className='flex flex-wrap '>
              <link
                rel='stylesheet'
                href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css'
              />
              <div className='lg:w-1/5 md:w-1/2 p-4 w-full'>
                <div className='mt-4'>
                  <Link to='/course'>
                    <div className='block relative h-32 rounded overflow-hidden bg-gradient-to-r from-blue-900 to-blue-200 text-white animate__animated animate__bounce shadow'>
                      <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                        Courses
                      </h2>
                      <p className='text-black text-2xl font-bold flex items-center justify-center '>
                        {loading ? (
                          <div className='loading-spinner'></div>
                        ) : (
                          formatNumberForDisplay(Number(course))
                        )}
                      </p>
                    </div>
                  </Link>
                </div>
              </div>

              <div className='lg:w-1/5 md:w-1/2 p-4 w-full'>
                <div className='mt-4'>
                  <Link to='/organization'>
                    <div className='block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#2eb85c] to-green-300 text-white animate__animated animate__bounce '>
                      <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                        Organizations{' '}
                      </h2>
                      <p className='text-black text-2xl font-bold flex items-center justify-center '>
                        {loading ? (
                          <div className='loading-spinner'></div>
                        ) : (
                          formatNumberForDisplay(Number(orgCount))
                        )}
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className='lg:w-1/5 md:w-1/2 p-4 w-full'>
                <div className='mt-4'>
                  {/* <Link to="/course"> */}
                  <div className='block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#f9b115] to-orange-300 text-white animate__animated animate__bounce'>
                    <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                      Students{' '}
                    </h2>
                    <p className='text-black text-2xl font-bold flex items-center justify-center '>
                      {loading ? (
                        <div className='loading-spinner'></div>
                      ) : (
                        formatNumberForDisplay(Number(student))
                      )}
                    </p>
                  </div>
                  {/* </Link> */}
                </div>
              </div>
              <div className='lg:w-1/5 md:w-1/2 p-4 w-full'>
                <div className='mt-4'>
                  <Link to='/assessment'>
                    <div className='block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#e55353] to-red-300 text-white animate__animated animate__bounce'>
                      <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                        Assessments
                      </h2>
                      <p className='text-black text-2xl font-bold flex items-center justify-center '>
                        {loading ? (
                          <div className='loading-spinner'></div>
                        ) : (
                          formatNumberForDisplay(Number(assessment))
                        )}
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className='lg:w-1/5 md:w-1/2 p-4 w-full'>
                <div className='mt-4'>
                  <Link to='/users'>
                    <div className='block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#39f] to-blue-300 text-white animate__animated animate__bounce'>
                      <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                        Users{' '}
                      </h2>
                      <p className='text-black text-2xl font-bold flex items-center justify-center '>
                        {loading ? (
                          <div className='loading-spinner'></div>
                        ) : (
                          formatNumberForDisplay(Number(users))
                        )}
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              <div
                className='lg:w-1/2 md:w-1/2 p-4 w-full'
                style={{ height: '500px' }}
              >
                <AgChartsReact options={options} />
              </div>
              <div
                className='lg:w-1/2 md:w-1/2 p-4 w-full'
                style={{ height: '500px' }}
              >
                <PieChart selectedYear={selectedYear} />
              </div>
              <div
                className='lg:w-full md:w-1/2 p-4 w-full'
                // style={{ overflowX: 'auto' }}
              >
                <div className='flex flex-nowrap'>
                  {cardsData.map((d: any) => (
                    <>
                      <div className='mx-auto mt-5 w-1/5'>
                        {/* <h2 className="text-2xl font-bold">{d.name}</h2> */}
                        <div className='block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#39f] to-blue-300 text-white animate__animated animate__bounce shadow'>
                          {' '}
                          <h2 className='text-gray-100 title-font text-xl font-bold p-4'>
                            {d.name}
                          </h2>
                        </div>

                        <div className='p-4 shadow-md '>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-evenly',
                              alignItems: 'center', // Added to vertically align the content
                              gap: '10px', // Added to create some spacing between the text and the line
                            }}
                          >
                            <div>
                              <span
                                style={{ fontSize: '20px', fontWeight: 'bold' }}
                              >
                                Users
                              </span>{' '}
                              <br />
                              <span
                                style={{ fontSize: '23px', marginLeft: '22px' }}
                              >
                                {formatNumberForDisplay(
                                  d.userOrganizationCount,
                                )}
                              </span>
                            </div>
                            <div
                              style={{
                                borderLeft: '1px solid black', // Added to create a vertical line
                                height: '50px', // Adjust the height of the line as needed
                              }}
                            />
                            <div>
                              <span
                                style={{ fontSize: '20px', fontWeight: 'bold' }}
                              >
                                Courses
                              </span>{' '}
                              <br />
                              <span
                                style={{ fontSize: '23px', marginLeft: '22px' }}
                              >
                                {formatNumberForDisplay(d.courseCount)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>

              <div
                className='lg:w-full md:w-1/2 p-4 w-full'
                style={{ height: '950px' }}
              >
                <ChartExample selectedYear={selectedYear} />
              </div>
            </div>
          </div>
        </section>
      )}
      {hasRole(RoleDefinitions.faculty) && (
        <div>
          <FacultyDashboard />
        </div>
      )}
      {/* <div id="container">
        <div style={gridStyle} className="ag-theme-alpine">
          <AgGridReact columnDefs={columnDefs}></AgGridReact>
        </div>
      </div> */}
    </>
  );
};
var myTheme: AgChartTheme = {
  baseTheme: 'ag-default-dark',
  palette: {
    fills: ['#5C2983', '#0076C5', '#21B372', '#FDDE02', '#F76700', '#D30018'],
    strokes: ['gray'],
  },
  overrides: {
    common: {
      title: {
        fontSize: 24,
      },
    },
    cartesian: {
      padding: {
        left: 70,
        right: 70,
      },
      series: {
        line: {
          marker: {
            shape: 'circle',
          },
        },
        column: {
          label: {
            enabled: true,
            color: 'white',
          },
        },
      },
      axes: {
        category: {
          line: {
            color: 'gray',
          },
          tick: {
            color: 'gray',
          },
        },
        number: {
          line: {
            color: 'gray',
          },
          tick: {
            color: 'gray',
          },
        },
      },
    },
    polar: {
      padding: {
        top: 40,
        bottom: 40,
      },
      legend: {
        position: 'left',
      },
      series: {
        pie: {
          calloutLabel: {
            enabled: true,
          },
          calloutLine: {
            colors: ['gray'],
          },
        },
      },
    },
  },
};
export default Dashboard;
